import { useMemo } from "react";
import { useTable } from "react-table";
import { convertToNumber } from "../../../../helpers";

export const useActivityLogRecords = ({ activityLogRecords = [] }) => {
  const columns = useMemo(
    () => [
      {
        Header: "Field Name",
        accessor: "key",
        Cell: ({ cell: { value } }) => value?.replace("_", " ") || "N/A",
      },
      {
        Header: "Before",
        accessor: "previous_val",
        Cell: ({ cell: { value } }) => convertToNumber(value || "N/A"),
      },
      {
        Header: "After",
        accessor: "current_val",
        Cell: ({ cell: { value } }) => convertToNumber(value || "N/A"),
      },
    ],
    [],
  );

  const tableInstance = useTable({
    columns,
    data: activityLogRecords,
  });

  return { instance: tableInstance };
};
